<template>
    <div>
        <div class="card-header">
            <div class="text-left">
                <button class="btn btn-success"  @click="activeExtra()">
                    <i class="fas fa-plus fa-lg"></i> Agregar Grupo
                </button>                
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div v-if="displayExtra == true" class="col-md-12">
                    <div class="activeLista extras-opciones">                    
                        <div class="list-group-item list-group-item-action" style="border: 0px !important; border-top:inherit !important; margin-bottom:30px;">
                            <form @submit.prevent="form()" style="width: 100%;">
                                <div class="row">
                                    <div class="form-group col-md-12">
                                        <label>Nombre del Grupo:</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            style="border: 1px solid #b1b1b1; width: 100% !important;"
                                            v-model="f.name"
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-md-2">
                                        <button
                                            type="submit"
                                            class="btn btn-info"
                                            :disabled="btnSave"                                            
                                        >
                                            <i class="fas fa-save fa-ms"></i>
                                            {{ $t("lang.label_save") }}
                                        </button>                                         
                                    </div>
                                    <div class="form-group col-md-3">
                                        <button class="btn btn" style="margin-left:10px"  @click="cancel()">
                                            Cancelar
                                        </button>                                           
                                    </div>                                    
                                </div>
                            </form>
                        </div> 
                    </div>
                </div>            
                <div class="col-md-12">
                    <draggable
                        v-model="groups"
                        tag="div"
                        class="row"
                        v-bind="dragOptions"
                        @start="isDragging = true"
                        @end="isDragging = false"
                        @change="moveGroup"
                        handle=".moveCat"
                        style="margin-left: 1px;"
                    >                
                        <div class="row list-group-item list-group-item-action ajustA" v-for="(i, index) in groups" :key="index" style="padding: inherit !important;">
                            <div class="moveCat">
                                <i class="fas fa-ellipsis-v"></i>
                            </div>                        
                            <div class="col-md-11 ajustB" @click="changeGroup(i, index)">
                                <a v-bind:class="[i.visible === 1 ? 'activeGroup' : '', 'text-left', 'ajustC']" style="">
                                    {{ i.name }}
                                    <b class="badge badge-success float-right ajustD" v-if="i.visible === 1" style="">
                                        {{ $t("lang.label_selected") }}
                                    </b>                           
                                </a>                          
                            </div>                            
                            <div v-if="i.primary_group !== 1"  class="col-md-1 cdropdown btnViewMore float-right ajustE">
                                <button><i class="fas fa-ellipsis-v"></i></button>
                                <label>
                                    <input type="checkbox" />
                                    <ul>
                                        <li @click="activateEditGroup(i, index)">
                                            {{ $t("lang.label_edit") }}
                                        </li>
                                        <li @click="removeGroup(i, index)">
                                            {{ $t("lang.label_del") }}
                                        </li>
                                    </ul>
                                </label>
                            </div>                      
                        </div>
                    </draggable>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import draggable from "vuedraggable"
export default {
    name: "ActionMenuChange",
    components: {
        draggable,
    },
    data () {
        return {
            f: {
                name: "",
                status: 1,
                user_id: window.localAccountID,
                org_id: window.localorgdata,
                order: 0,
                id: 0,
                primary_group: 0,
            },  
            btnSave: false,          
            m: {
                show: false,
                component: "",
                data: {},
            },
            groups:[],
            displayExtra:false,
        }
    },
    created () {
        this.init();
    },
    methods: {
        init() {
            let g = this.$store.getters["getOpenModal"];
            // console.log(g);
            let r = g.data
            if (r.actionForm === "ActionMenuChange") {
                this.groups = r.dat
            }            
        },
        cancel(){
            this.displayExtra = !this.displayExtra;
            this.refresh()
        },
        activateEditGroup(i, index){
            // console.log(i);
            this.f.name = i.name
            this.f.id = i.id
            this.activeExtra()
        },     
        activeExtra() {
            this.displayExtra = !this.displayExtra;
        }, 
        changeGroup(i, index) {
            if (i.id && i.id > 0) {
                this.$store.commit("setLoadingModal", true);              
                for (let e in this.groups) {
                    this.groups[e].visible = 0;
                }
                this.groups[index].visible = 1;
                this.commit(this.groups, index, i);                
                this.$store.commit("SET_GROUPACTIVE", i.id);
                this.f.name = "" 
                this.f.id = 0  
                this.groups = []               
            }            
        },
        commit(groups, index, i) {
            this.$store.commit("setLoadingModal", false);
            this.$store.commit("setCloseModal", { action: "saved" });
            let groupSelect = groups[index].name;
            let showGroup = false;
            this.m = {
                show: false,
                component: "",
                data: {
                    actions: "ReturnActionMenuChange",
                    groupSelect:groupSelect,
                    group:i.id,
                    showGroup:showGroup,
                    i:i
                },
            };
            this.$store.commit("setOpenModal", this.m);
            this.refresh()
        },
        addGroup(name, id){
            let index = this.groups.length           
            let t = this
            let i = {
                active: undefined,
                id: id,
                name: name,
                visible: 0,
                primary_group:0,
            }
            this.groups.push(i)
            this.changeGroup(i, index)
        },
        form() {            
            if (this.f.name.length > 0 || this.f.name !== "") {
                this.btnSave = true;
                this.$store.commit("setLoadingModal", true);                   
                let url = "/creategroup";
                if (this.f.id > 0) {
                    url = "/editgroup";
                }
                window.master
                    .post(url, this.f)
                    .then((response) => {
                        // console.log(response.data);
                        let id = response.data.id
                        this.$notify({
                            group: "noti",
                            title: window.lang2.label_save,
                            type: window.lang2.success,
                            text: window.lang2.label_success_send,
                        });
                        this.btnSave = false;
                        if (this.f.id === 0) {
                            this.addGroup(this.f.name, id)
                        } else {
                            this.commitDel(this.f.name)
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.btnSave = false;
                    });
            } else {
                this.btnSave = false;
                this.$notify({
                    group: "noti",
                    title: "ERROR",
                    type: "error",
                    text: window.lang2.label_name_empty,
                });
            }
        }, 
        removeGroup(i, index) {
            this.f.id = i.id              
            this.$swal({
                title: window.lang2.label_d_g,
                text: window.lang2.msj_you_sure,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: window.lang2.msj_del_it,
            }).then((result) => {
                if (result.value) {
                    this.$store.commit("setLoadingModal", true);  
                    window.master
                        .post("/delgroup", this.f)
                        .then((response) => {
                            // console.log(response);
                            this.groups.splice(index, 1);                            
                            this.commitDel()
                        })
                        .catch((error) => console.log(error));
                }
            });
        },
        moveGroup() {
            this.$store.commit("setLoadingModal", false);
            this.$store.commit("setCloseModal", { action: "saved" });            
            window.master
                .post("/movegroup", { move: this.groups })
                .then((response) => {
                    this.groups = response.data.list;
                })
                .catch((error) => {
                    console.log(error);
                });
            let t = this
            this.m = {
                show: false,
                component: "",
                data: {
                    actions: "ReturnActionMoveFood",
                    group:t.groups,
                },
            };
            this.$store.commit("setOpenModal", this.m);                
        },        
        commitDel(name) {
            this.$store.commit("setLoadingModal", false);
            this.$store.commit("setCloseModal", { action: "saved" });
            let t = this
            let groups = this.groups
            let visible = []
            let id = this.f.id
            for (const i in groups) {
                if (groups[i].id === id) {
                    if (groups[i].visible === 1) {
                        groups[i].name = this.f.name
                        visible.push(groups[i])
                    } else {
                        groups[i].name = this.f.name
                        visible.push(groups[i])                        
                    }
                }                
            }
            this.m = {
                show: false,
                component: "",
                data: {
                    actions: "ReturnActionMenuDel",
                    visible:visible
                },
            };
            this.$store.commit("setOpenModal", this.m);
            this.changeGroup(this.groups[0], 0)
            // this.refresh()
        }, 
        refresh(){
            this.f.name = "" 
            this.f.id = 0 
        }                                    
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    },    
}
</script>
<style>
.ajustE{
    margin-right: -10px; 
    right: 1px; 
    margin-top: 5px; 
    position: absolute !important;
}
.ajustD{
    font-size: 12px;
}
.ajustC{
    color: inherit !important;
    margin-left: -10px;
}
.ajustB{
    margin-left: 20px !important;
    padding: 10px !important;
}
.ajustA{
    cursor:pointer; 
    display: flex !important;
}
.table {
    width: 100% !important;
}
.moveCat {
    position: absolute;
    border: 0px solid #000;
    left: 5px;
    padding-top: 9px;
    padding-right: 2px;
    padding-bottom: 3px;
    padding-left: 4px;    
    height: 35px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    background-color: rgb(17 177 245 / 38%);
    cursor: move;
    top: 3px;   
}
.extra-content {
    padding: 0px 1px 5px 5px;
}
.extras-opciones {
    height: 0px;
    transform: scaleY(0);
    overflow: hidden;
    transition: transform 0.3s ease-out;
}
.activeLista.extras-opciones {
    overflow: initial !important;
    height: auto !important;
    transform: scaleY(1);
    transform-origin: top;
    border-top: 0px;
    padding-top: 5px;
}
.activeLista.showformop.extras-opciones .extra-content {
    padding-left: 0px !important;
}
a.activeGroup.text-left {
    font-weight: 600;
}
.cdropdown.btnViewMore > a:before,
.cdropdown.btnViewMore > button:before {
    content: "" !important;
    border-top: 0px;
    border-left: 0px;
    top: 0px;
    right: 0px;
    border-right: 0px;
}
.cdropdown.btnViewMore > a,
.cdropdown.btnViewMore > button {
    padding-right: 5px;
    padding-left: 5px;
    border: 0px;
}
.cdropdown.btnViewMore ul {
    right: 0px;
}
span.cdropdown.btnViewMore.float-right button {
    padding: 0px;
}
</style>